import React from 'react';

import TabsLayout from '../../../components/TabsLayout/TabsLayout';

import ExecutedList from './ExecutedList';
import ScheduledList from './ScheduledList';

interface ITabsProps {
	value: string;
	label: string;
	children: React.ReactNode;
}
export const jobListTabs: ITabsProps[] = [
	{
		value: '1',
		label: 'Scheduled',
		children: <ScheduledList />,
	},
	{
		value: '2',
		label: 'Executed',
		children: <ExecutedList />,
	},
];

const JobList = () => (
	<TabsLayout
		tabs={jobListTabs}
		customClass="tab-custom-style"
		isTabBar={false}
		deleteBtn
	/>
);

export default JobList;
